import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles((theme) => ({
  root: {
    padding: 0,
    [theme.breakpoints.down(theme.size.xs)]: {
      padding: 0,
    },
  },
}));
